import React from 'react'

const PageTitle = () => (
  <div className="col-md-10">
    <h1 className="page-title">
      Pitch
    </h1>
  </div>
)

export default PageTitle
